module.exports = __webpack_public_path__ + "static/media/arrow-next.0742ea35.svg";